import { render, staticRenderFns } from "./PropertyFormLinkForwarding.vue?vue&type=template&id=7381622a&scoped=true&"
import script from "./PropertyFormLinkForwarding.vue?vue&type=script&lang=js&"
export * from "./PropertyFormLinkForwarding.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFormLinkForwarding.vue?vue&type=style&index=0&id=7381622a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381622a",
  null
  
)

export default component.exports